import { SourceType } from '@foundation-player/runtime';

export const isVod = (type?: SourceType) => type === SourceType.VOD;

export const isLive = (type?: SourceType) =>
  type === SourceType.Live || type === SourceType.Event || type === SourceType.FAST || type == SourceType.Radio;
